module.exports = __webpack_public_path__ + "static/media/latest-news.18678ceb.png";